import { Button, Center, Flex, Show, Box } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import UTMLink from "@components/UTMLink";
import { LP_RESTAKE } from "@constants/analytics";
import { trackEvent } from "utils";

const SimpleHeader = ({
  hideRestake,
  secondaryVariant,
}: {
  hideRestake?: boolean;
  secondaryVariant?: boolean;
}) => {
  const variantStyle = secondaryVariant ? { bgColor: "#075A5A" } : {};
  return (
    <Center w="100%">
      <Box maxW="1344px" w="100%">
        <Flex
          justifyContent="space-between"
          p={{ base: "12px 16px", md: "40px 16px 0px" }}
          alignItems="center"
          maxW="1512px"
          w="full"
          {...variantStyle}
        >
          <Show below="md">
            <UTMLink href="/">
              <BaseImage
                src="/assets/kelp.svg"
                alt="kelp"
                height={32}
                width={80}
                loading="eager"
              />
            </UTMLink>
          </Show>

          <Show above="769px">
            <UTMLink href="/">
              <BaseImage
                src="/assets/kelp.svg"
                alt="kelp"
                height={40}
                width={106}
                loading="eager"
              />
            </UTMLink>
          </Show>

          {!hideRestake && (
            <UTMLink
              href="/restake"
              _hover={{
                borderBottom: "none",
              }}
              onClick={() => {
                trackEvent(LP_RESTAKE, {
                  triggerer: "header",
                });
              }}
            >
              <Button
                variant="unstyled"
                p={{ base: "12px 24px", md: "16px 24px" }}
                borderRadius="52px"
                h={{ base: "38px", md: "56px" }}
                fontSize={{ base: "12px", md: "16px" }}
                fontWeight="600"
                lineHeight="120%"
                color="#FFF"
                bg="textPrimary"
              >
                Restake
              </Button>
            </UTMLink>
          )}
        </Flex>
      </Box>
    </Center>
  );
};

export default SimpleHeader;
